var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app-header"}},[_c('v-toolbar-title',{staticClass:"ml-0 app-logo-container"},[_c('img',{staticClass:"app-logo",attrs:{"src":_vm.imgUrlWithContext,"alt":_vm.imgAlt}})]),_c('div',{staticClass:"app-logo-banner"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }